import { HttpClient } from "@angular/common/http";
import { Component, Input, OnInit, Renderer2, inject } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { DomSanitizer } from "@angular/platform-browser";
import { TranslateService } from "@ngx-translate/core";

import { NumberSeparatorPipe } from "src/app/core/pipes/number.separator.pipe";
import { ApiNotificationService } from "src/app/core/services/api-notification.service";
import { DialogService } from "src/app/core/services/dialog.service";
import { FileService } from "src/app/core/services/file.service";
import { MobileNumbersService } from "src/app/core/services/mobile-numbers.service";
import { DialogStatus } from "../../../core/services/dialog.service";
import { BaseMobilesAnalysisComponent } from "../mobiles-analysis-widget/base/base-mobiles-analysis.component";
import { UtilityService } from "./../../../core/services/utility.service";

@Component({
    selector: "app-mobile-file-uploader",
    templateUrl: "./mobile-file-uploader.component.html",
    styleUrls: ["./mobile-file-uploader.component.scss"],
    standalone: false
})
export class MobileFileUploaderComponent
  extends BaseMobilesAnalysisComponent
  implements OnInit
{
  //#region properties
  #dialogService = inject(DialogService);

  @Input("fileId") input_fileId: string = "fileUpload";
  @Input("label") input_label: string = "common.selectFile";
  @Input("placeholder") input_placeholder: string = "common.selectFile";
  @Input("form") input_form: FormGroup;
  @Input("groupName") input_formGroupName: string;
  @Input("hasForm") input_hasForm: boolean = true;
  @Input("controlName") input_formControlName: string;
  @Input("isDisabled") input_isDisabled: boolean = false;
  @Input("loading") loading: boolean = false;

  //#endregion

  constructor(
    protected apiNotificationService: ApiNotificationService,
    protected mobileNumbersService: MobileNumbersService,
    protected sanitizer: DomSanitizer,
    protected dialogService: DialogService,
    protected translate: TranslateService,
    protected UtilityService: UtilityService,
    protected fileService: FileService,

    protected numberSeparatorPipe: NumberSeparatorPipe,
    protected http: HttpClient,
    protected renderer: Renderer2
  ) {
    super(
      mobileNumbersService,
      sanitizer,
      dialogService,
      translate,
      UtilityService,
      fileService,
      numberSeparatorPipe,
      http,
      apiNotificationService,
      renderer
    );
  }

  ngOnInit() {
    if (this.input_formGroupName)
      this.input_form = this.input_form.controls[
        this.input_formGroupName
      ] as FormGroup;

    this.selectedMode = "uploadFile";
  }
  showErrorDialog(event: any) {
    this.#dialogService.openDialog({
      title: "common.error",
      message: event?.errorMessage,
      status: DialogStatus.error,
    });
  }
}
